<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> WPD IVR Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->



<!--IVR Dashboard - Location Perferance and  IVR Dashboard - Job Roles -->
             <div class="row row-replace m-t-10 menu-column">
                
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> IVR Dashboard - Location Perferance
                     </div>
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                             <tr>
                                 <th rowspan="2">Locations</th>
                                 <th rowspan="2">Total</th>
                                 <th colspan="3">Open</th>
                                 <th rowspan="2">Resolved</th>
                                 <th rowspan="2">Rejected</th>
                             </tr>
                            <tr>
                           <th>open for 0 - 3 days</th>
                           <th>open for 4 - 7 days</th>
                           <th>open for < 8 days</th>
                        </tr>
                         </thead>
                         
                        <tbody>
                            <tr>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                        </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> IVR Dashboard - Job Roles
                     </div>
                    <div class="table-responsive">
                        <table class="table table-align">
                            <thead>
                                <tr>
                                    <th rowspan="2">Job Roles</th>
                                    <th rowspan="2">Total</th>
                                    <th colspan="3">Open</th>
                                    <th rowspan="2">Resolved</th>
                                    <th rowspan="2">Rejected</th>
                                </tr>
                               <tr>
                              <th>open for 0 - 3 days</th>
                              <th>open for 4 - 7 days</th>
                              <th>open for < 8 days</th>
                           </tr>
                            </thead>
                            
                           <tbody>
                               <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                           </tbody>
                         </table>
                    </div>
                 </div>
             </div>


      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

